/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import cx from 'classnames';
import styles from './SkeletonLoading.module.scss';

type Props = {
  rootWrapperClassName?: string;
  stepperWithUnitPriceClassName?: string;
  buttonGroupClassName?: string;
};

export const CalmBoxStepperSkeleton = ({
  rootWrapperClassName,
  stepperWithUnitPriceClassName,
  buttonGroupClassName,
}: Props) => {
  return (
    <div className={cx(styles.wrapper, rootWrapperClassName)}>
      <div className={cx(styles.stepperWithEach, stepperWithUnitPriceClassName)}>
        <div className={cx(styles.container, buttonGroupClassName)}>
          <div className={styles.button}>−</div>
          <div className={styles.valueInput}>1</div>
          <div className={styles.button}>+</div>
        </div>
      </div>
    </div>
  );
};

export default CalmBoxStepperSkeleton;
